export default __webpack_public_path__ + "static/media/Hands.8f39ca94.svg";